var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.mergeProps.tag,{tag:"component",class:['label', ("typo--" + (_vm.mergeProps.size))],domProps:{"innerHTML":_vm._s(_vm.mergeProps.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }